import React from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Button,
    Box,
    Typography,
} from '@mui/material';
import {
    DateInput,
    Select,
    CommonModal,
} from '../index';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';

const decommissionReasons = [
    { label: 'Destroyed or Disposed', value: 10 },
    { label: 'Sold', value: 11 },
    { label: 'Returned to Landlord', value: 15 },
];

const DecommissionModal = ({
    open,
    header,
    onSubmit,
    closeModal,
    state,
    setDecommissionState,
    decommissionButtonDisabled,
}) => {
    return (
        <CommonModal
            open={open}
            close={closeModal}
            header={header}
            bottom={24}
            scroll="paper"
            paperSx={{ margin: { xs: 0, sm: '32px' }, width: { xs: '450px', md: '450px', lg: '100%' } }}
        >
            <Grid container spacing={2} sx={{ marginTop: '1%', padding: '0% 8%', mb: { xs: 2 } }}>
                <Grid item xs={12}>
                    <Select
                        required
                        value={state.reasonId}
                        onChange={e => setDecommissionState({ reasonId: e.target.value })}
                        label='Reason'
                        variant='standard'
                        options={decommissionReasons}
                    />
                </Grid>
                <Grid item xs={12} sx={{ marginBottom: '6%' }}>
                    <DateInput
                        isRequired
                        allowPast
                        label="Decommission Date"
                        variant="standard"
                        date={state.decommissionDate}
                        onChange={new_date => setDecommissionState({ decommissionDate: new_date })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            disabled={decommissionButtonDisabled}
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={onSubmit}
                            style={{
                                backgroundColor: decommissionButtonDisabled ? trakrefDisabledBlue : trakrefBlue
                            }}
                        >
                            <Typography
                                variant='h5'
                                sx={{
                                    padding: '1% 0%',
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontFamily: trakrefFontFamily
                                }}
                            >
                                Decommission Appliance
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </CommonModal>
    );
};

DecommissionModal.propTypes = {
    open: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    state: PropTypes.object.isRequired,
    setDecommissionState: PropTypes.func.isRequired,
    decommissionButtonDisabled: PropTypes.bool.isRequired,
};

export default DecommissionModal;
